export const calculatePercentageChange = (
  currentData: number,
  priorData: number,
  precision = 2,
): number => {
  if (priorData === 0) {
    // No prior data to compare against: flat if still 0, otherwise treat as full growth
    return currentData === 0 ? 0 : 100;
  }

  const percentage = ((currentData - priorData) / priorData) * 100;
  return precision === 0 ? Math.round(percentage) : Number(percentage.toFixed(precision));
};
